//function for displaying the image upload preview

console.log("Hello from image-upload-preview.js !");

const displayPreview = function (e, imageInput, thumbnaiPreviewId) {
  var files = imageInput.files;
  for (var i = 0; i < files.length; i++) {
    var file = files[i];
    var imageType = /image.*/;
    if (!file.type.match(imageType)) {
      continue;
    }
    var img = document.getElementById(thumbnaiPreviewId);
    img.file = file;
    var reader = new FileReader();
    reader.onload = (function (aImg) {
      return function (e) {
        aImg.src = e.target.result;
      };
    })(img);
    reader.readAsDataURL(file);
  }
};

// Global array to keep track of all selected files
let allProductImages = [];

const displayMultiplePreviews = function (e, imageInput, previewContainerId) {
  const newFiles = imageInput.files;
  const previewContainer = document.getElementById(previewContainerId);

  // Don't clear existing previews - just add new ones
  // Clear only if we're starting from scratch
  if (allProductImages.length === 0) {
    previewContainer.innerHTML = "";
  }

  // Limit to 20 images maximum
  const maxImages = 20;
  const existingCount = allProductImages.length;
  const availableSlots = maxImages - existingCount;

  if (availableSlots <= 0) {
    // Show warning if no slots available
    const warning = document.createElement("div");
    warning.className = "notification is-warning is-light mt-2";
    warning.style.width = "100%";
    warning.innerHTML = `<p>Limite de 20 images atteinte. Vous ne pouvez pas ajouter plus d'images.</p>`;

    // Remove any existing warning
    const existingWarning = previewContainer.querySelector(
      ".notification.is-warning"
    );
    if (existingWarning) {
      existingWarning.remove();
    }

    // Add new warning at the beginning of container
    previewContainer.insertBefore(warning, previewContainer.firstChild);
    return;
  }

  const filesToProcess = Array.from(newFiles).slice(0, availableSlots);

  // Process each new file
  filesToProcess.forEach((file, index) => {
    const imageType = /image.*/;
    if (!file.type.match(imageType)) {
      console.warn(`File ${file.name} is not an image and will be skipped`);
      return;
    }

    // Add to global array with a unique ID
    const fileId = Date.now() + Math.random();
    const fileData = {
      id: fileId,
      file: file,
    };
    allProductImages.push(fileData);

    // Create preview container
    const previewDiv = document.createElement("div");
    previewDiv.className = "preview-item";
    previewDiv.dataset.fileId = fileId;
    previewDiv.style.position = "relative";
    previewDiv.style.width = "200px";
    previewDiv.style.margin = "10px";
    previewDiv.style.order = allProductImages.length; // For ordering

    // Create image element
    const img = document.createElement("img");
    img.id = `preview-product-img-${fileId}`;
    img.className = "file-name";
    img.style.width = "100%";
    img.style.height = "150px";
    img.style.objectFit = "cover";
    img.style.borderRadius = "8px";
    img.style.border = "2px solid #ddd";
    img.alt = `Preview ${allProductImages.length}`;

    // Create remove button
    const removeBtn = document.createElement("button");
    removeBtn.type = "button";
    removeBtn.className = "delete is-small";
    removeBtn.style.position = "absolute";
    removeBtn.style.top = "5px";
    removeBtn.style.right = "5px";
    removeBtn.style.backgroundColor = "red";
    removeBtn.style.borderRadius = "50%";
    removeBtn.innerHTML = "&times;";
    removeBtn.onclick = function () {
      removeImageFromPreview(fileId);
    };

    // Create file info
    const info = document.createElement("div");
    info.className = "is-size-7 mt-2 has-text-centered";
    info.textContent = truncateFileName(file.name, 20);
    info.title = file.name;

    // Create position indicator
    const positionBadge = document.createElement("span");
    positionBadge.className = "tag is-dark is-small";
    positionBadge.style.position = "absolute";
    positionBadge.style.top = "5px";
    positionBadge.style.left = "5px";
    positionBadge.textContent = allProductImages.length;
    positionBadge.style.fontSize = "0.7rem";

    previewDiv.appendChild(img);
    previewDiv.appendChild(positionBadge);
    previewDiv.appendChild(removeBtn);
    previewDiv.appendChild(info);

    // Add to the beginning of preview container (newest first)
    previewContainer.insertBefore(previewDiv, previewContainer.firstChild);

    // Read and display the image
    const reader = new FileReader();
    reader.onload = (function (aImg) {
      return function (e) {
        aImg.src = e.target.result;
      };
    })(img);
    reader.readAsDataURL(file);
  });

  // Update all position badges
  updatePositionBadges();

  // Show warning if too many files were attempted
  if (newFiles.length > availableSlots) {
    const warning = document.createElement("div");
    warning.className = "notification is-warning is-light mt-2";
    warning.style.width = "100%";
    warning.innerHTML = `<p>Maximum ${maxImages} images autorisées. ${
      newFiles.length - availableSlots
    } image(s) ignorée(s) (${availableSlots} emplacement(s) restant(s)).</p>`;

    // Remove any existing warning
    const existingWarning = previewContainer.querySelector(
      ".notification.is-warning"
    );
    if (existingWarning) {
      existingWarning.remove();
    }

    // Add warning at the beginning
    previewContainer.insertBefore(warning, previewContainer.firstChild);
  }

  // Update the input's files to reflect all selected images
  updateFileInput(imageInput);
};

// Helper function to truncate file names
function truncateFileName(name, maxLength) {
  if (name.length <= maxLength) return name;
  return name.substring(0, maxLength - 3) + "...";
}

// Function to remove an image from preview and array
function removeImageFromPreview(fileId) {
  // Remove from global array
  allProductImages = allProductImages.filter((item) => item.id !== fileId);

  // Remove from DOM
  const previewDiv = document.querySelector(`[data-file-id="${fileId}"]`);
  if (previewDiv) {
    previewDiv.remove();
  }

  // Update position badges
  updatePositionBadges();

  // Update the file input
  const imageInput = document.querySelector("#file-upload-productImages");
  updateFileInput(imageInput);

  // Clear any warnings since we have space now
  const previewContainer = document.getElementById("product-images-preview");
  const warning = previewContainer.querySelector(".notification.is-warning");
  if (warning) {
    warning.remove();
  }
}

// Function to update all position badges
function updatePositionBadges() {
  const previewItems = document.querySelectorAll(".preview-item");
  previewItems.forEach((item, index) => {
    const badge = item.querySelector(".tag");
    if (badge) {
      badge.textContent = previewItems.length - index; // Reverse order (newest first)
    }

    // Update order for CSS flexbox ordering
    item.style.order = previewItems.length - index;
  });
}

// Function to update FileList to include all images
function updateFileInput(input) {
  const dt = new DataTransfer();

  // Add all files in reverse order (oldest first)
  const reversedFiles = [...allProductImages].reverse();
  reversedFiles.forEach((fileData) => {
    dt.items.add(fileData.file);
  });

  input.files = dt.files;

  // Show count
  updateImageCount();
}

// Function to update image count display
function updateImageCount() {
  let countDisplay = document.getElementById("image-count-display");

  if (!countDisplay) {
    const fileLabel = document.querySelector(".file-label span.file-label");
    countDisplay = document.createElement("span");
    countDisplay.id = "image-count-display";
    countDisplay.className = "ml-2 tag is-info is-light";
    fileLabel.parentNode.appendChild(countDisplay);
  }

  countDisplay.textContent = `${allProductImages.length}/20 images`;
}

// Update your event listeners
let productImagesInput = document.querySelector("#file-upload-productImages");

if (productImagesInput) {
  // Initialize empty array
  allProductImages = [];

  productImagesInput.addEventListener("change", function (e) {
    displayMultiplePreviews(e, productImagesInput, "product-images-preview");
  });

  // Also handle when form is reset
  const form = productImagesInput.closest("form");
  if (form) {
    form.addEventListener("reset", function () {
      allProductImages = [];
      const previewContainer = document.getElementById(
        "product-images-preview"
      );
      previewContainer.innerHTML = "";
      updateImageCount();
    });
  }
}

// Optional: Add drag and drop functionality
document.addEventListener("DOMContentLoaded", function () {
  const dropArea =
    document.querySelector(".file-cta") ||
    document.querySelector(".file-label");
  const fileInput = document.querySelector("#file-upload-productImages");

  if (dropArea && fileInput) {
    // Prevent default drag behaviors
    ["dragenter", "dragover", "dragleave", "drop"].forEach((eventName) => {
      dropArea.addEventListener(eventName, preventDefaults, false);
      document.body.addEventListener(eventName, preventDefaults, false);
    });

    // Highlight drop area when item is dragged over it
    ["dragenter", "dragover"].forEach((eventName) => {
      dropArea.addEventListener(eventName, highlight, false);
    });

    ["dragleave", "drop"].forEach((eventName) => {
      dropArea.addEventListener(eventName, unhighlight, false);
    });

    // Handle dropped files
    dropArea.addEventListener("drop", handleDrop, false);

    function preventDefaults(e) {
      e.preventDefault();
      e.stopPropagation();
    }

    function highlight(e) {
      dropArea.classList.add("is-primary");
    }

    function unhighlight(e) {
      dropArea.classList.remove("is-primary");
    }

    function handleDrop(e) {
      const dt = e.dataTransfer;
      const files = dt.files;

      if (files.length) {
        fileInput.files = files;
        const event = new Event("change", { bubbles: true });
        fileInput.dispatchEvent(event);
      }
    }
  }
});

let profileImageInput = document.querySelector(
  "#file-upload.button.is-dark.chooseFile.file-input"
);
let profileImageInput1 = document.querySelector(
  "#file-upload-preference.button.is-dark.chooseFile.file-input"
);

let ownerImageInput = document.querySelector(
  "#file-upload-owner.button.is-dark.chooseFile.file-input"
);
let uStoreImageInput = document.querySelector(
  "#file-upload-uStore.button.is-dark.chooseFile.file-input"
);
let productThumbnailInput = document.querySelector(
  "#file-upload-productThumbnail.button.is-dark.chooseFile.file-input"
);
let productImg1Input = document.querySelector(
  "#file-upload-productImg1.button.is-dark.chooseFile.file-input"
);
let productImg2Input = document.querySelector(
  "#file-upload-productImg2.button.is-dark.chooseFile.file-input"
);

if (profileImageInput) {
  profileImageInput.addEventListener("change", function (e) {
    displayPreview(e, profileImageInput, "thumbnail");
  });
}
if (profileImageInput1) {
  profileImageInput1.addEventListener("change", function (e) {
    displayPreview(e, profileImageInput1, "thumbnail-preference");
  });
}
if (ownerImageInput) {
  ownerImageInput.addEventListener("change", function (e) {
    displayPreview(e, ownerImageInput, "thumbnail-owner");
  });
}
if (uStoreImageInput) {
  uStoreImageInput.addEventListener("change", function (e) {
    displayPreview(e, uStoreImageInput, "thumbnail-uStore");
  });
}
if (productThumbnailInput) {
  productThumbnailInput.addEventListener("change", function (e) {
    displayPreview(e, productThumbnailInput, "thumbnail-product-thumbnail");
  });
}
if (productImg1Input) {
  productImg1Input.addEventListener("change", function (e) {
    displayPreview(e, productImg1Input, "thumbnail-product-img1");
  });
}
if (productImg2Input) {
  productImg2Input.addEventListener("change", function (e) {
    displayPreview(e, productImg2Input, "thumbnail-product-img2");
  });
}
